// @ts-nocheck
import { Box, Modal, Tooltip, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  closeSmsModalAction,
  fetchOlderSmsAction,
  fetchPeopleForSmsAction,
  openSendSmsModalAction,
} from "../../store/actions/sms/sms";
import { USER_ROLES } from "../../staticData/userRoles";
import { isUserRole } from "../../utils/methods/storeFunc";
import { SmsEventModal } from "./SmsEventModal";
import LoadingOverlay from "../Custom/LoadingOverlay";
import { CustomIconButton } from "../Custom/CustomIconButton";
import { Info, Mode } from "@mui/icons-material";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { getFirstUsersAndCount } from "../../utils/methods/formatters";
import { RiCheckDoubleFill } from "react-icons/ri";
import { RiErrorWarningFill } from "react-icons/ri";
import { formatDateTimeWithTimezone } from "../../appCalcutions/calcTime";

// Component for message with read more functionality
const MessageWithReadMore = ({ message }) => {
  const [expanded, setExpanded] = useState(false);

  if (!message) return null;

  const cleanMessage =
    message.split("Reply STOP to opt out. HELP for help.")?.[0] || message;
  const shouldTruncate = cleanMessage.length > 150;
  const displayMessage =
    expanded || !shouldTruncate
      ? cleanMessage
      : cleanMessage.substring(0, 150) + "...";

  return (
    <Box>
      <Typography sx={{ fontWeight: "300", display: "inline" }}>
        {displayMessage}
      </Typography>
      {shouldTruncate && (
        <Typography
          component="span"
          onClick={() => setExpanded(!expanded)}
          sx={{
            fontWeight: "500",
            color: getCssVariableHandler({
              variableName: "--primary-pink-hex",
            }),
            cursor: "pointer",
            marginLeft: "0.5rem",
            fontSize: "0.875rem",
            "&:hover": {
              opacity: 0.8,
            },
          }}
        >
          {expanded ? "Read less" : "Read more"}
        </Typography>
      )}
    </Box>
  );
};

MessageWithReadMore.propTypes = {
  message: PropTypes.string,
};

const style = {
  boxShadow: 24,
  p: 3,
  pb: 0,
  borderRadius: "16px",
  padding: "20px",
  paddingRight: "0px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
  width: "500px",
  maxHeight: "90vh",
  // minWidth: "300px",
  maxWidth: "1000px",
  minHeight: "400px",
  // overflowY: "auto",
  transition: "all 0.3s ease",
  "@media (max-width: 600px)": {
    maxHeight: "97vh",
    maxWidth: "95vh",
  },
};

export const SmsHistoryEventModal = () => {
  const { initialPeople } = useSelector((state) => state?.smsReducer);
  const { eventInfo } = useSelector((state) => state?.eventRequestDetails);
  const { smsModalStatus, smsHistoryLoading, smsHistory, isDM } = useSelector(
    (state) => state?.smsReducer,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (!smsModalStatus) return;
    const payload = {
      params: {
        // DM = conversation with the person; `eventInfo` is stale global state
        // off an event page and would filter the history by an unrelated event
        // (same reasoning as SmsEventModal's submit).
        eventId: isDM ? undefined : eventInfo?._id,
        ...(initialPeople.length > 0 && { userId: initialPeople[0]?._id }),
        ...(initialPeople.length > 0 && {
          senderId: initialPeople[0]?.senderId,
        }),
      },
    };

    dispatch(
      fetchOlderSmsAction({
        payload,
      }),
    );
    dispatch(
      fetchPeopleForSmsAction({
        payload,
      }),
    );
  }, [eventInfo?._id, dispatch, smsModalStatus, isDM]);

  function onClose() {
    dispatch(closeSmsModalAction());
  }

  // const buttonList = [
  //   {
  //     label: "Client",
  //     type: USER_ROLES.CLIENT,
  //   },
  //   {
  //     label: "Contractor",
  //     type: USER_ROLES.CONTRACTOR,
  //   },
  //   {
  //     label: "Coordinator",
  //     type: USER_ROLES.COORDINATOR,
  //   },
  //   {
  //     label: "Admin",
  //     type: USER_ROLES.ADMIN,
  //   },
  //   {
  //     label: "All",
  //     type: "All",
  //   },
  // ];

  function composeClickHandler() {
    dispatch(openSendSmsModalAction());
  }

  if (isDM) {
    return isUserRole(
      USER_ROLES.SUPERADMIN,
      USER_ROLES.ADMIN,
      USER_ROLES.COORDINATOR,
    ) ? (
      <SmsEventModal isDM />
    ) : null;
  }

  return (
    <Modal
      open={smsModalStatus}
      onClose={onClose}
      sx={{
        zIndex: 2000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          ...style,
          display: "flex",
          justifyContent: "flex-start",
          aliginItems: "flex-start",
          gap: "1rem",
          flexDirection: "column",
          position: "relative",
        }}
      >
        <CustomIconButton
          sx={{
            position: "absolute",
            bottom: "1rem",
            right: "1rem",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            padding: "0.5rem 1rem",
            borderRadius: "0.75rem",
            backgroundColor: getCssVariableHandler({
              variableName: "--primary-pink-hex",
            }),
            transition: "opacity 0.3s ease",
            "&:hover": {
              backgroundColor: getCssVariableHandler({
                variableName: "--primary-pink-hex",
              }),
              opacity: "0.8",
            },
            zIndex: 10,
          }}
          onClick={composeClickHandler}
        >
          <Typography component={"span"} fontWeight={"500"}>
            Compose
          </Typography>
          <Mode fontSize="small" />
        </CustomIconButton>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingRight: "20px",
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              fontSize: "1.25rem",
              fontWeight: "500",
            }}
          >
            Text Messages
          </Typography>

          <Typography
            sx={{
              fontSize: "1rem",
            }}
          >
            {!initialPeople[0]?.senderId
              ? eventInfo?.eventName
              : initialPeople[0]?.name}
          </Typography>
        </Box>

        {/* NOTE: messages here */}
        {smsHistoryLoading ? (
          <LoadingOverlay open={true} />
        ) : smsHistory?.length == 0 ? (
          <Typography
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              flexGrow: "1",
              mb: "5rem",
              opacity: "0.8",
            }}
          >
            No messages
          </Typography>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              flexDirection: "column",
              gap: "0.5rem",
              overflowY: "auto",
              paddingRight: "20px",
              paddingBottom: "20px",
            }}
            className="custom-scroll-design"
          >
            {smsHistory?.map((msg) => (
              <Box
                key={msg?.parentId}
                sx={{
                  border: "1px solid",
                  padding: "0.5rem 0.75rem",
                  borderRadius: "0.5rem",
                  width: "100%",
                  borderColor: getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  }),
                }}
              >
                {/* From and To section */}
                <Box
                  sx={{
                    paddingBottom: "0.5rem",
                    borderBottom: "1px solid rgba(209, 117, 182, 0.3)",
                  }}
                >
                  {/* From */}
                  <Typography sx={{ fontSize: "1rem", marginBottom: "0.1rem" }}>
                    <Typography
                      component="span"
                      sx={{ opacity: 0.7, fontSize: "1rem" }}
                    >
                      From:{" "}
                    </Typography>
                    <Typography
                      component="span"
                      sx={{ fontWeight: "500", fontSize: "1rem" }}
                    >
                      {msg?.sender?.name}
                    </Typography>
                    {msg?.sender?.userRole && (
                      <Typography
                        component="span"
                        sx={{
                          fontSize: "1rem",
                          opacity: 0.6,
                          textTransform: "capitalize",
                          marginLeft: "0.25rem",
                        }}
                      >
                        ({msg?.sender?.userRole})
                      </Typography>
                    )}
                  </Typography>

                  {/* To */}
                  {!initialPeople[0]?.senderId && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <Typography
                        component="span"
                        sx={{ opacity: 0.7, fontSize: "1rem" }}
                      >
                        To:{" "}
                      </Typography>
                      <Tooltip
                        arrow
                        title={
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "flex-start",
                              gap: "0.25rem",
                              flexDirection: "column",
                            }}
                          >
                            {msg?.users?.map((u) => (
                              <Typography key={u?._id}>
                                {u?.preferredName || u?.name}
                              </Typography>
                            ))}
                          </Box>
                        }
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontWeight: "500",
                            fontSize: "1rem",
                            cursor: "help",
                          }}
                        >
                          {getFirstUsersAndCount({ usersArr: msg?.users })}
                        </Typography>
                      </Tooltip>
                      {/* <Tooltip
                        arrow
                        title={
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "flex-start",
                              gap: "0.5rem",
                              width: "100%",
                              flexDirection: "column",
                            }}
                          >
                            {msg?.users?.map((u) => (
                              <Typography
                                key={u?._id}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  gap: "1rem",
                                  width: "100%",
                                }}
                              >
                                {u?.preferredName || u?.name}
                                {u?.status?.toLowerCase() == "delivered" ? (
                                  <RiCheckDoubleFill />
                                ) : (
                                  <Tooltip arrow title={"Failed to send message"}>
                                    <div style={{ cursor: "pointer" }}>
                                      <RiErrorWarningFill
                                        color={getCssVariableHandler({
                                          variableName: "--red-shade-1rgb",
                                        })}
                                      />
                                    </div>
                                  </Tooltip>
                                )}
                              </Typography>
                            ))}
                          </Box>
                        }
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "help",
                          }}
                        >
                          <Info sx={{ fontSize: "1.25rem", color:'primary.main' }} />
                        </Box>
                      </Tooltip> */}
                    </Box>
                  )}
                </Box>

                {/* Message content */}
                <MessageWithReadMore message={msg?.message} />

                {/* Timestamp */}
                <Typography
                  sx={{
                    fontWeight: "300",
                    fontSize: "0.75rem",
                    opacity: 0.7,
                  }}
                >
                  {formatDateTimeWithTimezone(msg?.smsSentOn)}
                </Typography>
              </Box>
            ))}
          </Box>
        )}

        {isUserRole(
          USER_ROLES.SUPERADMIN,
          USER_ROLES.ADMIN,
          USER_ROLES.COORDINATOR,
        ) && <SmsEventModal />}
      </Box>
    </Modal>
  );
};

SmsHistoryEventModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  successCb: PropTypes.func,
  title: PropTypes.string,
  isLoading: PropTypes.bool,
  pageName: PropTypes.string,
};